var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "rgba(12, 35, 68, 1)",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9108 17.7854C10.2719 17.8743 5.71451 19.2345 1.77186 21.5842L0.903809 22.1016V32.0007H2.68159H29.3483V22.1398L28.5324 21.6153C24.2708 18.8778 19.5497 17.6963 14.9108 17.7854Z",
    fill: "#0C2344"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.126 0.000732422C11.2197 0.000732422 8.01489 3.20554 8.01489 7.11187C8.01489 11.0182 11.2197 14.223 15.126 14.223C19.0323 14.223 22.2372 11.0182 22.2372 7.11187C22.2372 3.20554 19.0323 0.000732422 15.126 0.000732422Z",
    fill: "#0C2344"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7927 8.31879V10.3094H33.7553V8.31879H25.7927Z",
    fill: "#0C2344"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7787 5.33279V13.2954H30.7693V5.33279H28.7787Z",
    fill: "#0C2344"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.4c2a5c1212eb327cb58ba5aebb116a7a.svg";
export { ForwardRef as ReactComponent };